import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'atlasPercent', standalone: true })
export class PercentPipe implements PipeTransform {
  transform(value: number, rawPercent?: boolean): string {
    if (!value) {
      return '0%';
    }

    let correctValue = value;

    if (rawPercent === true) {
      correctValue = Math.round(value * 100);
    }

    return correctValue.toString() + '%';
  }
}
